import { render, staticRenderFns } from "./ChoosePaymentSystem.vue?vue&type=template&id=15fe2552&scoped=true&"
import script from "./ChoosePaymentSystem.vue?vue&type=script&lang=ts&"
export * from "./ChoosePaymentSystem.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePaymentSystem.vue?vue&type=style&index=0&id=15fe2552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe2552",
  null
  
)

export default component.exports